// extracted by mini-css-extract-plugin
export default {"disconnectedPullRequestLink":"DisconnectedEvent-module__disconnectedPullRequestLink__bQw8sYt"};